import { Divider } from '../elements/Divider';
import MoneyFormat from '../elements/MoneyFormat';
import { DiscountRow } from './DiscountRow';

interface DiscountOverviewProps {
  discountCode: string;
  discountPrice: number;
  totalPrice: number;
  subtotalPrice: number;
  className?: string;
}

export function DiscountOverview({
  discountCode,
  discountPrice,
  totalPrice,
  subtotalPrice,
  className = '',
}: DiscountOverviewProps) {
  return (
    <div className={className}>
      <Divider />

      <DiscountRow
        className="GiftBox-Discount-Screen-Subtotal mt-4"
        label="Subtotal"
        price={MoneyFormat({ amount: subtotalPrice / 100 })}
        data-cy="subtotal"
      />

      {discountCode ? (
        <DiscountRow
          className="GiftBox-Discount-Screen-Discount mt-2"
          label={`Discount ${discountCode}`}
          price={MoneyFormat({
            amount: discountPrice / 100,
            shouldAddNegativePrefixSign: true,
          })}
          data-cy="discount"
        />
      ) : null}

      <Divider className="my-4" />

      <div className="flex justify-between items-center">
        <span className="text-heading-sm">Total</span>
        <span
          className="GiftBox-Discount-Screen-Total text-heading-md"
          data-cy="total"
        >
          {MoneyFormat({ amount: totalPrice / 100 })}
        </span>
      </div>
    </div>
  );
}
